export interface PetInsuranceView {
  full_contract_number: string;
  base_number: string;
  name: string;
  image?: string;
  annualFranchiseOverall: number;
  annualFranchiseRemaining: number;
  insuredSumOverall: number;
  insuredSumRemaining: number;
  contractStatus:  'expired' | 'active' | 'future';
  species: string;
}
